import React from 'react'
import './Cont2.css'
export default function Container2() {
  return (
    <>
    <div className='container py-5 my-4 '>
        <h3 className='fw-bold'>Bleib nicht auf der Strecke</h3>
        <h1 className='fw-bold'>Unsere <span className='text-success1'>zufriedenen Kunden</span></h1>
        
        <div className=' row  px-0 py-2 mt-4 mb-5 Cont2 cont2d-flex'>
        <img src='./cont2img1.png' alt='not found' className='cont3_img1   my-1'></img>
        <img  src='./cont2img2.png' alt='not found' className='cont3_img   my-1'></img>
        <img  src='./cont2img3.png' alt='not found' className='cont3_img   my-1' ></img>
        <img  src='./cont2img4.png' alt='not found' className='cont3_img  my-1'></img>
       
        </div>
        </div>
        
    
    </>
  )
}
